// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3338":"22da786c","5834":"f3ad64d9"}[chunkId] + ".chunk.css";
};